import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@material-ui/core";
import { Typography } from "@mui/material";

function formatBrl(value) {
  const num = Number(value) || 0;
  return num.toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
}

export default function ModalItensNota({ open, onClose, itens, numeroNota }) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth>
      <DialogTitle>
        <Typography variant="body1">
          Itens da Nota Fiscal {numeroNota || ""}
        </Typography>
      </DialogTitle>
      <DialogContent>
        <TableContainer>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Código do Produto</TableCell>
                <TableCell>Nome do Produto</TableCell>
                <TableCell align="right">Quantidade</TableCell>
                <TableCell align="right">Valor Unitário</TableCell>
                <TableCell align="right">Valor Total</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {(itens || []).map((item) => (
                <TableRow key={`${item.IdProduto}-${item.Quantidade}`}>
                  <TableCell>{item.IdProduto}</TableCell>
                  <TableCell>{item.NomeProduto}</TableCell>
                  <TableCell align="right">{item.Quantidade}</TableCell>
                  <TableCell align="right">
                    {formatBrl(item.ValorUnitario)}
                  </TableCell>
                  <TableCell align="right">
                    {formatBrl(item.ValorTotal)}
                  </TableCell>
                </TableRow>
              ))}
              {(!itens || itens.length === 0) && (
                <TableRow>
                  <TableCell colSpan={5} align="center">
                    Nenhum item encontrado.
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          Fechar
        </Button>
      </DialogActions>
    </Dialog>
  );
}
